module.exports = __webpack_public_path__ + "static/media/aahar_icon.56b82045.png";